import React, { useEffect } from "react";
import styles from "./Home.module.css";
// import logo from "../../../public/images/logo_main.png";
import { Link } from "react-router-dom";

import Registration from "../../components/Registration/Registration";
import ScrollArrow from "../../components/ScrollArrow/ScrollArrow";
import Loader from "../../components/Loader";

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [imgLoad, setImgLoad] = React.useState(true);


  return (
    <div className={`${styles.display}`}>
      {/* Logo and Pages navigation Layout - Desktop and Tablet view */}
      <div className={styles.landingPC}>
        <div className={styles.title}>Vyuhaa'23</div>
        <div className={styles.exl}>EXCLUSIVELY FOR FIRST YEARS</div>
        <div className={styles.date}>October 14</div>
        <div className={styles.grid}>
          <div className={styles.gridContainer}>
            {/* <div className={`${styles.gridItem} ${styles.gi_Left}`}>
              <Link to="/ktalk">
                <p>K!talk</p>
              </Link>
            </div> */}
            
            <div className={`${styles.gridItem} ${styles.gi_Left}`}>
              <Link to="/workshops">
                <p>Workshop</p>
              </Link>
            </div>
            
            <div className={`${styles.gridItem} ${styles.gi_Left}`}>
              <Link to="/events">
                <p>Events</p>
              </Link>
            </div>
            
          
            {/* <div className={`${styles.gridItem} ${styles.gi_Left}`}>
              <Link to="/vr">
                <p>VR Expo</p>
              </Link>
            </div> */}
          </div>


          <div className={`${styles.gridItem} ${styles.logoImg}`}>
            <a href="#regContainer">
              {imgLoad && <div style={{
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "8rem"
              }}
              >
                <Loader />  </div>
              }
              <img
                onLoad={() => setImgLoad(false)}
                style={{ display: imgLoad ? "none" : "block" }}
                src={`${process.env.PUBLIC_URL}/images/logo_main.png`} alt={"Logo"} />
            </a>
          </div>

          <div className={styles.gridContainer}>
            <div className={`${styles.gridItem} ${styles.gi_Right}`}>
              <Link to="/innodesign">
                <p>InnoDesign</p>
              </Link>
            </div>
         
            <div className={`${styles.gridItem} ${styles.gi_Right}`}>
              <a
                href="https://cegtechforum.in/contact"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>Contact</p>
              </a>
            </div>
          </div>
        </div>
        <a href="#regContainer">
          <ScrollArrow />
        </a>

      </div>

      {/* Logo and Pages navigation Layout - Mobile view */}
      <div className={styles.landingMOBILE}>
        <div className={styles.logo_container}>
          <div className={styles.heading}>Vyuhaa'23</div>
          <div className={styles.exlM}>EXCLUSIVELY FOR FIRST YEARS</div>
          <div className={styles.date}>October 14</div>
          <div className={styles.img_container}>
            <a href="#options">
              {imgLoad && <div style={{
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "8rem"
              }}
              >
                <Loader />  </div>
              }
              <img
                onLoad={() => setImgLoad(false)}
                style={{ display: imgLoad ? "none" : "block" }}
                src={`${process.env.PUBLIC_URL}/images/logo_main.png`} alt={"Logo"} />
            </a>
          </div>
          <a href="#regContainer">
            <ScrollArrow />
          </a>
        </div>
        <div className={styles.link_container} id="options">
          <div className={styles.links}>
            <Link to="/events">
              <p>Events</p>
            </Link>
          </div>
          <div className={styles.links}>
            <Link to="/workshops">
              <p>Workshop</p>
            </Link>
          </div>
          {/* <div className={styles.links}>
            <Link to="/ktalk">
              <p>K!talk</p>
            </Link>
          </div> */}
          <div className={styles.links}>
            <Link to="/innodesign">
              <p>InnoDesign</p>
            </Link>
          </div>
          {/* <div className={styles.links}>
            <Link to="/vr">
              <p>VR Expo</p>
            </Link>
          </div> */}
          <div className={styles.links}>
            <a
              href="https://cegtechforum.in/contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>Contact</p>
            </a>
          </div>
        </div>
      </div>

      {/* General Registration - Generates Vyuhaa ID*/}
      <div id="regContainer" className={styles.reg_container}>
        <Registration />
      </div>
    </div>
  );
}

export default Home;
